import Container from "@mui/material/Container";
import { useSelectorApp } from "../../lib/redux";
import CompleteRegistrationForm from "./components/CompleteRegistrationForm";

const CompleteRegistration = () => {
  const { theme } = useSelectorApp((state) => state.ui);

  return (
    <Container
      maxWidth="md"
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <img
        src={theme.logo}
        alt="Logo"
        style={{ width: "50%", maxWidth: 300 }}
      />
      <CompleteRegistrationForm />
    </Container>
  );
};

export default CompleteRegistration;
